export const unitOfMeasureOptions = [
  { value: "Each", label: "Each" },
  { value: "Pack", label: "Pack" },
  { value: "Case", label: "Case" },
  { value: "Pallet", label: "Pallet" },
  { value: "Roll", label: "Roll" },
  { value: "Vault", label: "Vault" },
  { value: "Bucket", label: "Bucket" },
  { value: "Box", label: "Box" },
  { value: "Bundle", label: "Bundle" },
  { value: "Set", label: "Set" },
  { value: "Lot", label: "Lot" },
  { value: "Linear Yard", label: "Linear Yard" },
  { value: "Square Yard", label: "Square Yard" },
].sort((a, b) => a.value.localeCompare(b.value));

export default unitOfMeasureOptions;
